import Card from '../components/spotlights/Card';
import { withDeepLink } from './HybirdContext.container';

export default withDeepLink(Card);
